import type { Value } from 'platejs';
import { isEmptyDocument } from '../PlateEditor/serializers/plateToHtml';
import type { PlateNode } from '../PlateEditor/serializers/plateToHtmlTypes';

/**
 * Synchronous emptiness check for the compose-email Plate body.
 *
 * Delegates to the serializer's `isEmptyDocument` so this render-time
 * Preview/Send guard stays in lockstep with plateToHtml's '' contract (an
 * all-whitespace doc serializes to '') from a single source of truth for the
 * void/media set, instead of a hand-synced copy of the walk.
 */
export function isComposeBodyEmpty(value: Value | undefined | null): boolean {
    if (!Array.isArray(value) || value.length === 0) return true;
    return isEmptyDocument(value as PlateNode[]);
}
